<template>
  <div
    class="saved-card"
    :class="{ active: paymentMethod && paymentMethod.id === card.id }"
    @click="selectCard"
  >
    <div class="checkbox">
      <div class="check"></div>
    </div>
    <img class="card-logo" :src="cardLogo" :alt="cardLogo.brand" />
    <div class="card-name">{{ cardName }}</div>
    <div class="card-number">***{{ card.last4 }}</div>
    <div class="expire">Exp {{ expireDate }}</div>
  </div>
</template>

<script>
import { CREDIT_CARD_ASSETS, CREDIT_CARD_NAME } from "@/constants/payment"

export default {
  props: ["card", "paymentMethod"],
  computed: {
    cardLogo () {
      return CREDIT_CARD_ASSETS[this.card.brand]
    },
    expireDate () {
      const month =
        this.card.exp_month < 10
          ? `0${this.card.exp_month}`
          : this.card.exp_month
      const year = this.card.exp_year.toString().slice(2)
      return `${month}/${year}`
    },
    cardName () {
      return CREDIT_CARD_NAME[this.card.brand]
    },
  },
  methods: {
    selectCard () {
      this.$emit("setPaymentMethod", this.card)
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/style/_mixins.scss";
.saved-card {
  height: 5.9rem;
  display: grid;
  grid-template-columns: 1fr 1.5fr 2.5fr 1.5fr 2fr;
  align-items: center;
  padding: 0 1.8rem;
  font-size: 1.4rem;
  text-align: left;
  cursor: pointer;
  transition: all 0.1s;
  border-radius: 8px;
  @include phone-down {
    padding: 0 1rem;
    grid-template-columns: 1fr 1.5fr 2.5fr 2fr 2fr;
  }
  &:hover,
  &.active {
    background: #f3f3f3;
  }
  &.active {
    .checkbox {
      background: #f24462;
      .check {
        width: 1rem;
        height: 1rem;
        border-radius: 50%;
        background: #f0f0f0;
      }
    }
  }
  .checkbox {
    width: 2rem;
    height: 2rem;
    border-radius: 50%;
    border: 1px solid #e1e1e1;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .card-logo {
    width: 4.1rem;
  }
  .card-name {
    font-weight: 600;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/payment/SavedCard.vue